<template>
  <div>
    <!-- ROW: firstName / lastName -->
    <div class="md-layout">
      <!-- FIRSTNAME -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('firstName') && touched.firstName },
            { 'md-form-group': true },
            { 'md-error': errors.has('firstName') }
          ]"
        >
          <md-icon>person_outline</md-icon>
          <label>First Name</label>
          <md-input v-validate="'required'" v-model="firstName" type="text" name="firstName" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('firstName')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('firstName') && touched.firstName" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- LASTNAME -->
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-100">
          <md-field
            :class="[
              { 'md-valid': !errors.has('lastName') && touched.lastName },
              { 'md-form-group': true },
              { 'md-error': errors.has('lastName') }
            ]"
          >
            <md-icon>record_voice_over</md-icon>

            <label>Last Name</label>
            <md-input
              v-validate="'required'"
              v-model="lastName"
              data-vv-name="lastName"
              type="text"
              name="lastName"
              required
            />

            <slide-y-down-transition>
              <md-icon v-show="errors.has('lastName')" class="error">close</md-icon>
            </slide-y-down-transition>

            <slide-y-down-transition>
              <md-icon v-show="!errors.has('lastName') && touched.lastName" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <!-- ROW: email / DOB -->
      <!-- EMAIL -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('email') && touched.email },
            { 'md-form-group': true },
            { 'md-error': errors.has('email') }
          ]"
        >
          <md-icon>mail_outline</md-icon>
          <label>Email</label>
          <md-input v-validate="'required'" v-model="email" type="email" name="email" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('email')" class="error">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('email') && touched.email" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- ROW: cellPhone / allowSMS -->
      <!-- CELLPHONE -->
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-65">
          <md-field
            :class="[
              { 'md-valid': !errors.has('cellPhone') && touched.cellPhone },
              { 'md-form-group': true },
              { 'md-error': errors.has('cellPhone') }
            ]"
          >
            <md-icon>phone</md-icon>
            <label>Cell Phone</label>
            <md-input
              v-validate="{ required: true, min: 10 }"
              v-mask="'(999) 999 - 9999'"
              v-model="cellPhone"
              type="text"
              name="cellPhone"
            />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('cellPhone')" class="error">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('cellPhone') && touched.cellPhone" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>

        <!-- ALLOW SMS -->
        <div class="md-layout-item" style="padding: 0px">
          <!--<md-icon>sms</md-icon>-->

          <md-switch v-model="allowSMS"><span class="lbl1">Allow SMS</span></md-switch>
        </div>
      </div>

      <!-- DOB -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field
          :class="[
            { 'md-valid': !errors.has('DOB') && touched.DOB },
            { 'md-form-group': true },
            { 'md-error': errors.has('DOB') },
            { 'md-has-value': true }
          ]"
          style="margin-left: 0"
        >
          <md-icon>today</md-icon>
          <label for="DOB">Date Of Birth</label>
          <md-input
            v-validate="'required'"
            id="DOB"
            v-model="DOB"
            style="border-bottom: solid 1px lightgray !important"
            data-vv-name="DOB"
            name="DOB"
            placeholder=" "
            type="date"
            @pick="updateDOB"
          />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('DOB')" class="error" style="margin-right: 15px">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- ROW: gender / height -->

      <!-- GENDER -->
      <div class="md-layout-item md-size-50 md-small-size-100" style="padding-left: 0">
        <md-field
          :class="[
            { 'md-valid': !errors.has('gender') && touched.gender },
            { 'md-form-group': true },
            { 'md-error': errors.has('gender') }
          ]"
          style="margin: 0; max-height: 60px; align-items: center"
        >
          <md-icon style="margin-right: 0; padding-right: 10px">man_4</md-icon>
          <div style="margin-left: 15px">
            <md-radio v-model="gender" value="Male" style="padding-right: 30px"
              ><span style="margin-top: -9px; position: absolute; font-size: 14px">Male</span></md-radio
            >
            <md-radio v-model="gender" value="Female"
              ><span style="margin-top: -9px; position: absolute; font-size: 14px">Female</span></md-radio
            >
          </div>

          <slide-y-down-transition>
            <md-icon v-show="errors.has('gender')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('gender') && touched.gender" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- LANGUAGE -->
      <div class="md-layout-item md-size-100">
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-45">
            <md-field
              :class="[
                { 'md-valid': !errors.has('language') && touched.language },
                { 'md-form-group': true },
                { 'md-error': errors.has('language') }
              ]"
            >
              <md-icon>language</md-icon>
              <label class="spaced-phone-label">Languages spoken</label>
              <md-input v-model="language" data-vv-name="language" type="text" name="language" />
              <slide-y-down-transition>
                <md-icon v-show="errors.has('language')" class="error">close</md-icon>
              </slide-y-down-transition>
              <slide-y-down-transition>
                <md-icon v-show="!errors.has('language') && touched.language" class="success">done</md-icon>
              </slide-y-down-transition>
            </md-field>
            <span v-if="language != ''" style="font-size: 0.8em">Separate language with a comma.</span>
          </div>

          <div class="md-layout-item" style="padding: 0px">
            <div class="md-inline-checkboxes" style="line-height: 10px; font-size: 0.75rem">
              <div class="modify-checkbox">
                <md-checkbox v-for="(item, index) in languagesList" :key="item.LookupId" v-model="item.selected">{{
                  item.DisplayValue
                }}</md-checkbox>
                <md-checkbox v-model="chk_OtherLang">Other</md-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { IconCheckbox } from "@/components"
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"
import $ from "jquery"

export default {
  components: {
    IconCheckbox,
    SlideYDownTransition
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chk_OtherLang: false,
      languagesList: [],
      firstName: "",
      lastName: "",
      isReader: false,
      email: "",
      DOB: "",
      cellPhone: "",
      allowSMS: false,
      language: "",
      otherLanguage: "",

      gender: "",
      touched: {
        firstName: false,
        lastName: false,
        email: false,
        DOB: false,
        cellPhone: false,
        gender: false,
        language: false,
        otherLanguage: false
      }
    }
  },
  mounted() {
    this.defineLookups()
  },
  computed: {
    ...mapGetters(["rdPersonal", "isPhone"])
  },
  watch: {
    firstName() {
      this.touched.firstName = true
    },
    lastName() {
      this.touched.lastName = true
    },
    email() {
      this.touched.email = true
    },
    DOB() {
      this.touched.DOB = true
    },
    cellPhone() {
      this.touched.cellPhone = true
    },

    gender() {
      this.touched.gender = true
    }
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    updateSelectedLookups(lookupList, storedIds) {
      if (storedIds.length > 0) {
        return lookupList.map((lookup) => ({
          ...lookup,
          selected: storedIds.includes(lookup.LookupId.toString())
        }))
      } else {
        return lookupList
      }
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    nameToLookup(lookupList, id) {
      let lookupItem = lookupList.find((item) => item.LookupId === +id)
      if (lookupItem) {
        return lookupItem.LookupId
      } else {
        return null
      }
    },
    async defineLookups() {
      try {
        const languages = await this.fetchLookupByName("Languages")
        this.languagesList = languages.map((i) => ({ ...i, selected: false }))
        if (this.isEdit) {
          this.fillValues()
        }
      } catch (error) {
        console.error("Error fetching lookups:", error)
      }
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    },
    updateDOB() {
      this.DOB = this.picker.getDate(true)
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      // Ensures leading zeros in month/day
      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, "0")
      const dd = String(date.getDate()).padStart(2, "0")
      return `${yyyy}-${mm}-${dd}`
    },
    fillValues() {
      this.firstName = this.rdPersonal.firstName
      this.lastName = this.rdPersonal.lastName
      this.email = this.rdPersonal.email
      this.DOB = this.formatDate(this.rdPersonal.DOB)
      this.cellPhone = this.rdPersonal.cellNumber
      this.allowSMS = this.rdPersonal.allowSMS
      this.isReader = this.rdPersonal.isReader
      this.gender = this.rdPersonal.gender

      // Extract stored languages
      if (this.rdPersonal.languages === null) {
        this.rdPersonal.languages = ""
      }
      const isOtherFlow = this.rdPersonal.languages.includes(";Other;")
      let storedLanguages = []
      if (!isOtherFlow) {
        this.chk_OtherLang = ""
        const isMultiple = this.rdPersonal.languages.includes(";")
        if (isMultiple) {
          storedLanguages = this.rdPersonal.languages.split(";")
        } else {
          storedLanguages = [this.rdPersonal.languages]
        }
      }
      if (isOtherFlow) {
        storedLanguages = this.rdPersonal.languages.split(";Other;")[0].split(";")
        this.language = this.rdPersonal.languages.split(";Other;")[1]
        this.chk_OtherLang = true
      }
      this.languagesList = this.updateSelectedLookups(this.languagesList, storedLanguages)

      if (!this.rdPersonal.insurances) {
        this.rdPersonal.insurances = ""
      }
    },
    storeValues() {
      console.log("storeValues", this.DOB)
      this.rdPersonal.firstName = this.firstName
      this.rdPersonal.lastName = this.lastName
      this.rdPersonal.email = this.email
      this.rdPersonal.DOB = this.DOB
      this.rdPersonal.cellNumber = this.cellPhone
      this.rdPersonal.allowSMS = this.allowSMS
      this.rdPersonal.isReader = this.isReader
      this.rdPersonal.gender = this.gender
      let idList = this.languagesList
        .filter((i) => i.selected) // Get selected LookupId
        .map((i) => i.LookupId)
      this.rdPersonal.languages = idList.length > 1 ? idList.join(";") : idList[0] || ""
      if (this.language != "") {
        this.rdPersonal.languages += `;Other;${this.language}`
      }
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.lbl1 {
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.6);
}

.md-select menu .md-list-item .md-list-item-content {
  min-height: 25px;
}

.md-card-wizard .tab-content {
  padding: 20px, 0px;
}
</style>

<style lang="scss">
#no-side-padding {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.modify-checkbox {
  .md-checkbox-label {
    padding-left: 5px;
  }
}
</style>
